import React from 'react';
import './courseProvideCard.css'

function C2wCourseProvideCard( { obj=null, index = null} ) {
  return (
    <div className={`C2wCourseProvideCard_ctn C2wCourseProvideCard_ctn${index + 1}`}>
        <div className='count'>{obj?.count}</div>
        <div className='title'>{obj?.title}</div>
    </div>
  )
}

export default C2wCourseProvideCard
